import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { IAppState } from '../state';
import { authReducer } from './auth.reducers';
import { visitorsReducer } from './visitors.reducers';
import { usersReducer } from './users.reducers';
import { destinationsReducer } from './destinations.reducers';
import { reasonsReducer } from './reasons.reducers';
import { destinationReasonsReducer } from './destination-reasons.reducers';

export const appReducers: ActionReducerMap<IAppState, any> = {
  router: routerReducer,
  auth: authReducer,
  visitors: visitorsReducer,
  users: usersReducer,
  destinations: destinationsReducer,
  reasons: reasonsReducer,
  destinationReasons: destinationReasonsReducer,
};
